import { useState } from "react";
import { Link } from "react-router-dom";
import { LockKeyhole, ArrowLeft } from "lucide-react";
import { api, errMsg } from "../../lib/api";

export const PasscodeGate = ({ onUnlock }) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/admin/login", { passcode: code });
      onUnlock();
    } catch (err) {
      setError(errMsg(err, "Access denied"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="lab-screen flex items-center justify-center p-6">
      <form data-testid="admin-login-form" onSubmit={submit} className="relative z-10 w-full max-w-md border border-cyan-400/30 bg-slate-950/85 p-8 backdrop-blur-xl">
        <span className="corner corner-tl" /><span className="corner corner-br" />
        <LockKeyhole className="text-cyan-300" size={32} />
        <p className="lab-label mt-6">The Spore Project // Restricted // Lab technicians only</p>
        <h1 className="spore-headline mt-2 text-3xl">Programming bench</h1>
        <label htmlFor="passcode" className="lab-label mt-8 block">Passcode</label>
        <input
          id="passcode"
          data-testid="admin-passcode-input"
          type="password"
          autoFocus
          value={code}
          onChange={(e) => setCode(e.target.value)}
          className="lab-input mt-2 w-full text-xl tracking-[0.4em]"
          autoComplete="current-password"
        />
        {error && <p data-testid="admin-login-error" className="mt-3 font-mono text-sm text-rose-400">{error}</p>}
        <button data-testid="admin-login-submit" disabled={busy || !code} className="lab-btn-primary mt-6 w-full justify-center">
          {busy ? "Verifying..." : "Unlock setup"}
        </button>
        <Link data-testid="back-to-kiosk-link" to="/" className="mt-6 flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-slate-500 hover:text-cyan-300 transition-colors">
          <ArrowLeft size={14} /> Back to kiosk
        </Link>
      </form>
    </div>
  );
};
